import { makeStyles } from 'tss-react/mui';

interface IOrderBookCardStyleProps {
  activeOrder?: boolean;
  isSuggestedOrder?: boolean;
}

export const useOrderBookCardStyles = makeStyles<IOrderBookCardStyleProps>()(
  (theme, { activeOrder, isSuggestedOrder }) => {
    const isActiveSuggested = !!(activeOrder && isSuggestedOrder);
    const contrastColor = isActiveSuggested ? { color: theme.palette.primary.contrastText } : {};

    const getCardBackground = () => {
      if (isActiveSuggested) {
        return theme.palette.primary.main;
      }
      if (activeOrder) {
        return theme.palette.secondary.dark;
      }
      return theme.palette.background.paper;
    };

    return {
      card: {
        boxSizing: 'border-box',
        borderRadius: theme.shape.borderRadiusLg,
        border: `1px solid ${theme.palette.custom.border.primary}`,
        backgroundColor: getCardBackground(),
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(1, 1.5),
        maxWidth: '348px',
        [theme.breakpoints.down('sm')]: {
          maxWidth: '100%',
        },
        ...(isActiveSuggested && {
          '& .MuiTypography-root': {
            color: theme.palette.primary.contrastText,
          },
        }),
      },
      codeContainer: {
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
        flex: 1,
        rowGap: '2px',
      },
      valueText: {
        textAlign: 'right',
      },
      customerName: {
        fontWeight: theme.typography.fontWeightMedium,
      },
      activeText: {
        ...contrastColor,
      },
      starIcon: {
        color: activeOrder ? theme.palette.primary.contrastText : theme.palette.common.black,
      },
      iconBox: {
        display: 'flex',
        paddingLeft: theme.spacing(1.25),
      },
      actionIcon: {
        color: theme.palette.accent.light,
        ...contrastColor,
      },
    };
  },
);
